require 'angular'

angular.module( 'workflow.app' )
  .controller( 'MoveFindingModalController', require './MoveFindingModalController' )

angular.module( 'workflow.app' )
  .controller( 'DeleteFindingModalController', require './DeleteFindingModalController' )
